module.exports = __webpack_public_path__ + "static/404-cat-5db586f38c52981923ee9ba00cbeaac0.gif";